import React from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ErrorIcon from "@mui/icons-material/Error";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import SyncIcon from "@mui/icons-material/Sync";
import { keyframes } from "@mui/material";

import type { TaskStep } from "./taskSteps";

export const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`;

export function StepStatusIcon({ status }: { status: TaskStep["status"] }) {
  switch (status) {
    case "completed":
      return <CheckCircleIcon sx={{ fontSize: 18, color: "success.main" }} />;
    case "failed":
      return <ErrorIcon sx={{ fontSize: 18, color: "error.main" }} />;
    case "in_progress":
      return (
        <SyncIcon
          sx={{
            fontSize: 18,
            color: "info.main",
            animation: `${pulse} 1.5s infinite`,
          }}
        />
      );
    case "queued":
      return <HourglassEmptyIcon sx={{ fontSize: 18, color: "grey.500" }} />;
    case "skipped":
      return <ChevronRightIcon sx={{ fontSize: 18, color: "grey.400" }} />;
    default:
      return (
        <HourglassEmptyIcon sx={{ fontSize: 18, color: "warning.main" }} />
      );
  }
}
